import { Component, OnInit } from '@angular/core';
import { Service } from '../services';
import { GlobalService } from '../global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { Subscription } from "rxjs";
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-recharge',
  templateUrl: './recharge.component.html',
  styleUrls: ['./recharge.component.sass']
})
export class RechargeComponent implements OnInit {
  public tabActive='Pagos y Facturas';
  public selectBan;
  public banlist;
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public token:string=sessionStorage.getItem("token");
  public screenView=1;
  public amount;
  public subscriber;
  public totalPagar;
  public tax;
  public idProduct;
  public total;
  public authorizationNumber;
  public prepaidPaymentAddress2=[];
  loadObserver: Subscription;
  initialize: Subscription;
  constructor(private loadingScreenService :LoadingScreenService,private services: Service,public global:GlobalService,private router: Router,private route: ActivatedRoute,public AngularFireAnalytics:AngularFireAnalytics) {
    this.AngularFireAnalytics.setCurrentScreen("Recarga de Prepago");
    this.AngularFireAnalytics.logEvent("Recarga de Prepago-Screenview");
   }

  ngOnInit() {
    this.global.validateSession();
    if(this.global.sessionReview()==true){

      this.banlist=JSON.parse(atob(sessionStorage.getItem("AccountList")));
      this.selectBan=atob(sessionStorage.getItem("selectBan"));
      this.subscriber = this.global.getSuscriberByDefault(this.selectBan);
      this.initialize = this.global.initialize.subscribe((value:number) => {
        this.initializeData();
      });
      this.loadObserver = this.global.loadObserver.subscribe((value:number) => {
        this.dataLoading(value)
      });
      this.getId();
    }
  }
  ngOnDestroy() {
    this.loadObserver.unsubscribe();
    this.initialize.unsubscribe();
  }
  refreshDataTo(event:Event) {
    let index =parseInt(event.target["selectedIndex"]);
    let ban = this.currentList[index].account;
    sessionStorage.setItem("selectBan",btoa(ban));
    this.initializeData();
  }
  initializeData(){
    this.global.refreshDataTo(this.token);
  }
  dataLoading(sw){
    this.loadingScreenService.stopLoading();
  }
  getId() {
    if(this.route.firstChild) {
      let id = this.route.firstChild.snapshot.params.id;
      let amount = this.route.firstChild.snapshot.params.amount;
      if (id == '1') {
        this.screenView=1;
      }
      else if (id == '2') {
        let ivuState=0.115;
        this.amount=amount;
        this.tax = amount * ivuState;
        this.totalPagar = parseFloat(this.amount) + this.tax;
        this.idProduct=24;
        this.screenView=2;
      }
      else {
        this.screenView=1;
        this.router.navigate(['politics']);
      }
    }
  }
}
